import React from "react";
import { useSelector } from "react-redux";
import InventoryOnboarding from "./onboarding/InventoryOnboarding";
import InventoryPrincipal from "./principal/InventoryPrincipal";
import InventoryInventory from "./inventory/InventoryInventory";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";

const Inventory = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_principal) {
      return <InventoryPrincipal />;
    }
    if (state.auth.user.is_inventory) {
      return <InventoryInventory />;
    }
    if (state.auth.user.is_onboarding) {
      return <InventoryOnboarding />;
    }
    return <PermissionDenied />;
  }
};

export default Inventory;
